<template>
  <v-app class="hc-compact-page hc-schedule-page">
    <div>

      <!-- Header Card -->
            <PageHeader icon="far fa-calendar-alt">
        <template #title>
          Jadwal Dokter {{ clinic_name }}
        </template>
        <template #subtitle>
          Kelola waktu operasional, jadwal praktik, dan hari libur dokter
        </template>
        <template #actions>
          <b-button
                    class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                    @click="btnAddOnClick"
                    v-b-modal.modal-form>
                    <i class="fas fa-plus"></i>
                    <span>Tambah Hari Libur</span>
                  </b-button>
        </template>
      </PageHeader>

      <ScheduleTabs />

      <!-- Holiday List -->
      <div class="row">
        <div class="col-md-12">
          <Card>
            <template v-slot:body>
              <CalendarDataWorkspace v-model="activeMode" @change="workspaceModeOnChange">
                <template #filters>
                  <label class="holiday-doctor-filter hc-no-form-icons" for="holiday-doctor-filter">
                    <span>Dokter</span>
                    <treeselect
                      id="holiday-doctor-filter"
                      v-model="filter.doctor_id"
                      :multiple="false"
                      :options="doctors"
                      :clearable="true"
                      placeholder="Semua dokter"
                      class="hc-no-form-icons"
                      @input="filterDoctorOnSelect" />
                  </label>
                </template>

                <Calendar
                  v-if="activeMode === 'calendar' && renderComponent"
                  :doctor-id="filter.doctor_id" />
                <Table
                  v-else-if="activeMode === 'table'"
                  :fields="fields"
                  :items="items"
                  :perPage="perPage"
                  :currentPage="currentPage"
                  :totalRows="totalRows"
                  :hasDoctor="true"
                  @pageOnClick="pageOnClick"
                  @btnEditOnClick="btnEditOnClick"
                  @btnDeleteOnClick="btnDeleteOnClick" />
              </CalendarDataWorkspace>
            </template>
          </Card>
        </div>
      </div>

      <!-- Modal Form -->
      <Form
        :form="form"
        :route="route"
        :editTarget="editTarget"
        :hasDoctor="false"
        @formOnSubmit="formOnSubmit"
      />

    </div>
  </v-app>
</template>

<script>

import Form from '@/component/holidays/Form.vue'
import Table from '@/component/holidays/Table.vue'
import Card from "@/view/content/Card.vue"
import Calendar from '@/component/holidays/Calendar.vue'
import CalendarDataWorkspace from '@/component/common/CalendarDataWorkspace.vue'
import ScheduleTabs from '@/component/schedules/ScheduleTabs.vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import DoctorModule from '@/core/modules/DoctorModule'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form,
    Table,
    Calendar,
    CalendarDataWorkspace,
    ScheduleTabs,
    Treeselect,
  },

  data() {
    return {
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Filter
      filter: {
        doctor_id: null
      },
      doctors: [],
      activeMode: 'calendar',
      // Form
      form: {
        doctor_id: '',
        start_date: '',
        end_date: '',
        notes: ''
      },
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: 'doctor_name',
          label: 'Dokter',
          sortable: true,
        },
        {
          key: "date",
          label: "Tanggal",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // Other
      route: 'holidays',
      editTarget: '',
      renderComponent: true,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      const doctorId = this.filter.doctor_id == null ? '' : this.filter.doctor_id
      let filterParams = `&doctor_id=${doctorId}`
      let response = await module.paginate('holidays', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total
      
      let a, b
      b = this.perPage * (this.currentPage - 1) + 1  
      for(a = 0; a < response.data.length; a++){
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    btnTabCalendarOnClick() {
      // Remove my-component from the DOM
      this.renderComponent = false
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true
      })
    },

    workspaceModeOnChange(mode) {
      if (mode === 'calendar') this.btnTabCalendarOnClick()
    },

    async getDoctors() {
      const data = await DoctorModule.getTreeSelect()
      this.doctors = (Array.isArray(data) ? data : []).filter((doctor) => {
        const label = doctor && String(doctor.label || '').trim()
        return doctor && doctor.id !== '' && label && label.toLowerCase() !== '(unknown)'
      })
    },

    formOnSubmit() {
      this.btnTabCalendarOnClick()
      this.pagination()
    },

    async filterDoctorOnSelect(doctorId) {
      this.filter.doctor_id = doctorId == null ? null : doctorId
      this.currentPage = 1
      this.pagination()
    },

    btnAddOnClick() {
      this.editTarget = ""
    },

    async btnEditOnClick(id) {
      this.editTarget = id.toString()
      this.form = await module.get('holidays/' + id)
      this.form['_method'] = 'put'
    },

    async btnDeleteOnClick(id) {
      // Delete Data
      let result = await module.delete('holidays/' + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

  },

  mounted() {    
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Jadwal Dokter", route: "" },
      { title: "Hari Libur" },
    ])    
    this.getDoctors()
    this.pagination()
  }

}

</script>

<style lang="scss">
@import "~vuetify/dist/vuetify.css";

.theme--light.v-application {
  background: transparent !important;
}

.v-application code {
  box-shadow: none !important;
}

.hc-schedule-header-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #ffffff;
  border: 1px solid #e7edf4;
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(20, 50, 99, 0.05);
}

.hc-schedule-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  margin-right: 16px !important;
  border-radius: 12px;
  background: rgba(30, 149, 143, 0.08);
  color: #1e958f;
  font-size: 18px;
}

.hc-schedule-header-title {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  color: #1a2433;
}

.hc-schedule-header-sub {
  font-size: 12px;
  color: #64748b;
}

.hc-btn-tambah-jadwal {
  border-radius: 10px !important;
  min-height: 42px !important;
  padding: 0 22px !important;
  background: linear-gradient(135deg, #14608f, #1e958f) !important;
  border: none !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 14px rgba(30, 149, 143, 0.25) !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;

  i, span {
    color: #ffffff !important;
  }

  &:hover, &:focus, &:active {
    background: linear-gradient(135deg, #0f4c72, #187b76) !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(30, 149, 143, 0.35) !important;

    i, span {
      color: #ffffff !important;
    }
  }
}

.holiday-doctor-filter {
  display: block;
  width: min(100%, 310px);
  margin: 0;
}

.holiday-doctor-filter > span {
  display: block;
  margin-bottom: 0.28rem;
  color: #334155;
  font-size: 0.75rem;
  font-weight: 600;
}

.holiday-doctor-filter .vue-treeselect__control {
  height: 40px;
  border: 1px solid #d6e1eb;
  border-radius: 10px;
  box-shadow: none;
}

.holiday-doctor-filter .vue-treeselect__placeholder,
.holiday-doctor-filter .vue-treeselect__single-value {
  line-height: 38px;
  color: #64748b;
  font-size: 0.82rem;
  font-weight: 300;
}

.holiday-doctor-filter .vue-treeselect--focused .vue-treeselect__control,
.holiday-doctor-filter .vue-treeselect--open .vue-treeselect__control {
  border-color: #158d88;
  box-shadow: 0 0 0 3px rgba(21, 141, 136, 0.1);
}

@media (max-width: 767.98px) {
  .holiday-doctor-filter { width: 100%; }
}
</style>
